import React, { useState } from "react";
import { Paper, Grid } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  InputOptionMaster,
  InputCheckboxMaster,
} from "App/Component/ui";
import {
  RESET_STATE_MASTER_GUDANG,
  STYLE_MASTER_GUDANG,
  urlCreate,
  urlUpdate,
} from ".";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DEFAULT_VALUE_OPTION,
  DISABLED_BUTTON_SUBMIT,
  instance4,
  TYPE_INSTANCE4,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useInitialMasterGudangUtama, useSelectOption } from "App/hooks";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export default function FormMasterGudang({
  formData,
  setFormData,
  setNewData,
}) {
  const classes = STYLE_MASTER_GUDANG();
  const gudangUtama = useInitialMasterGudangUtama(
    false,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudangUtama
  );
  const unit = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudang.getGudangUnit,
    TYPE_INSTANCE4
  );

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance4.post(urlCreate, {
      ...formData,
    });
  };

  const update = () => {
    return instance4.post(urlUpdate, {
      ...formData,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          const res = await add();
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil menambah gudang");
            setNewData();
          } else {
            defaultToastError(res.data.message);
          }
        } else if (formData.id !== "") {
          const res = await update();
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil mengubah gudang");
            setNewData();
          } else {
            defaultToastError(res.data.message);
          }
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_MASTER_GUDANG);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={1} style={{
            display:'flex',
            alignItems:'center'
          }}>
            <InputCheckboxMaster
              name='isjual'
              label='Jual'
              id='isjual'
              checked={formData.status_jual}
              style={{
                marginTop: "-8px",
                width: "31px",
                height: "22px",
              }}
              endContent={true}
              value={formData.status_jual}
              onChange={()=>setFormData({ ...formData, status_jual: !formData.status_jual })}
              placeholder='ID'
            />
          </Grid>
          <Grid item sm={2}>
            <InputTextMaster
              name="id"
              label="ID"
              id="id"
              value={formData.id}
              onChange={handleChange("id")}
              placeholder="ID"
              disabled={true}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="id_gudang"
              label="GUDANG UTAMA"
              id="id_gudang"
              withSearch={false}
              data={
                gudangUtama?.length > 0
                  ? gudangUtama
                  : [DEFAULT_VALUE_OPTION("id_gudang")]
              }
              value={formData.id_gudang}
              onChange={handleChange("id_gudang")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name="name"
              label="NAMA"
              id="name"
              placeholder="Nama"
              value={formData.name}
              onChange={handleChange("name")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="id_unit"
              label="Unit"
              id="id_unit"
              withSearch={true}
              value={formData.id_unit}
              labelValue={formData.unit}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    id_unit: null,
                    unit: "Pilih Unit",
                  });
                } else {
                  setFormData({
                    ...formData,
                    id_unit: e.value,
                    unit: e.label,
                  });
                }
              }}
              data={unit}
              error={true}
            />
          </Grid>
        </Grid>

        <div className="mt-2">
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <MasterButton
              outline={true}
              type={"button"}
              onClick={() => {
                setFormData(RESET_STATE_MASTER_GUDANG);
              }}
              color="danger"
              name="Reset"
              size="md"
            />
            <MasterButton
              outline={false}
              type={"submit"}
              color={disabled.color}
              name={disabled.label}
              disabled={disabled.state}
              size="md"
            />
          </Grid>
        </div>
      </form>
    </Paper>
  );
}
